
export class ColaboradorHorario {
    colaboradorhorarioid: number = 0;
    colaboradorid: number = 0;
    cicloid: number = 0;
    semestreid: number = 0;
    lunesentrada: string = "";
    lunessalida: string = "";
    martesentrada: string = "";
    martessalida: string = "";
    miercolesentrada: any = "";
    miercolessalida: string = "";
    juevesentrada: string = "";
    juevessalida: string = "";
    viernesentrada: string = "";
    viernessalida: string = "";
    sabadoentrada: string = "";
    sabadosalida: string = "";
    domingoentrada: string = "";
    domingosalida: string = "";
    especial: boolean = false;
    horarioespecial: string = "";
    fecha: string = "";
    usuario: string = "";


    constructor(init?: Partial<ColaboradorHorario>) {
        Object.assign(this, init);
    }
}
